import {CurrencyFormat} from '../../server/rainbow/types';

export type ChannelPriceFormat = {
  currencyCode: string;
  decimalSeparator?: string;
  currencyFormat: CurrencyFormat;
};

export function formatPrice(
  amount: number | string,
  channelPriceFormat: ChannelPriceFormat,
): string {
  const amountString = typeof amount === 'number' ? amount.toFixed(2) : amount;
  const separatedAmount = amountString.toString().split('.');
  const shouldShowDecimal = separatedAmount[1] !== '00';

  const price = {
    currencySymbol: getCurrencySymbol(channelPriceFormat.currencyCode),
    beforeDecimal: separatedAmount[0],
    separator: shouldShowDecimal
      ? channelPriceFormat.decimalSeparator || '.'
      : '',
    afterDecimal: shouldShowDecimal ? separatedAmount[1] : '',
  };
  const p = `${price.beforeDecimal}${price.separator}${price.afterDecimal}`;

  switch (channelPriceFormat.currencyFormat) {
    case 'symbol_start':
      return `${price.currencySymbol}${p}`;
    case 'symbol_end':
      return `${p}${price.currencySymbol}`;
    case 'code_start':
      return `${channelPriceFormat.currencyCode}${p}`;
    case 'code_end':
      return `${p}${channelPriceFormat.currencyCode}`;
    case 'whitespace_symbol':
      return `${p}\u00A0${price.currencySymbol}`;
    case 'symbol_whitespace':
      return `${price.currencySymbol}\u00A0${p}`;
    case 'whitespace_code':
      return `${p}\u00A0${channelPriceFormat.currencyCode}`;
    case 'code_whitespace':
      return `${channelPriceFormat.currencyCode}\u00A0${p}`;
    default:
      console.warn(
        `Unknown channel currency symbol "${channelPriceFormat.currencyFormat}"`,
      );
      return `${price.currencySymbol}${p}`;
  }
}

function getCurrencySymbol(currencyCode: string): string {
  const currencyCodeSymbols: {[key: string]: string | undefined} = {
    GBP: '£',
    USD: '$',
    EUR: '€',
  };
  const currencySymbol = currencyCodeSymbols[currencyCode];
  if (currencySymbol === undefined) {
    return '';
  }
  return currencySymbol;
}

export function getPriceAmount(priceString: string) {
  const [units, cents] = priceString.match(/\d+/g) ?? [];
  if (units) {
    // float precision handling
    let amount = Number(units) * 100;
    if (cents) {
      amount += Number(cents);
    }
    return amount / 100;
  }
}
